export const mutations = {
  setAthleteList: (state, payload) => {
    state.athleteList = payload;
  },
  setAthleteOfficialResults: (state, payload) => {
    state.athleteOfficialResults = payload;
  },
  setAthleteResults: (state, payload) => {
    state.athleteResults = payload;
  },
  setResultsList: (state, payload) => {
    state.resultsList = payload;
  },
  setAllClubFormData(state, data) {
    state.allClubFormData = data;
  },
  setPersonCommunications: (state, payload) => {
    state.allPersonCommunications = payload;
  }
};
